import { initGdpr } from '../util/gdpr_consent'
import { updateConvertConsent } from '../util/convert_ab_testing'
import { updateGtagConsent } from '../util/google_tag_manager'
import { updateAmplitudeConsent } from '../util/amplitude'
import { updateMetaPixelConsent } from '../util/meta_pixel'
import { updateTikTokPixelConsent } from '../util/tik_tok_pixel'
import { on } from 'shared/javascripts/util/events'

on('gdpr:vendor-grant-changed', () => {
  updateConvertConsent()
  updateAmplitudeConsent()
  updateMetaPixelConsent()
  updateTikTokPixelConsent()
  // Didomi drives Google consent mode natively; the SourcePoint fallback does not, so we do it here.
  if (window.gdprConsentConfig?.mode === 'sourcepoint') {
    updateGtagConsent()
  }
})

initGdpr()
